// This module provides API call methods for Sephora Commerce
// Utility Store Locator API:
// https://jira.sephora.com/wiki/display/ILLUMINATE/Store+Locator+API

import getStoreLocations from 'services/api/utility/storeLocator/getStoreLocations';

export default { getStoreLocations };
